import React, { useContext } from 'react';

import { ShowIntercomContext } from 'common/containers/IntercomContainer';

import APIDocsBlock from '../APIDocsBlock';

const APIDocsAIBlock = () => {
  const showIntercom = useContext(ShowIntercomContext);

  return (
    <APIDocsBlock>
      <div>
        <div className="heading">AI Feedback Processing</div>
        <div className="text">
          For Canny accounts within the inbox closed beta, we offer direct access to the API that
          enqueues feedback for extraction and deduplication. This allows you to programmatically
          send feedback to Canny for processing.
          <br />
          <br />
          The Inbox provides a centralized view of all feedback that has been processed by our AI.
          For instance, duplicates we have identified in existing posts, or feature requests we have
          extracted from a source like Intercom.
        </div>
        <button className="showIntercomButton" onClick={showIntercom}>
          Contact support
        </button>{' '}
        to get access to this feature.
      </div>
      <div></div>
    </APIDocsBlock>
  );
};

export default APIDocsAIBlock;
